import { render, staticRenderFns } from "./WorkInformation.vue?vue&type=template&id=1dde45a0&"
import script from "./WorkInformation.vue?vue&type=script&lang=js&"
export * from "./WorkInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports